const LoadingOverlay = () => {
  return (
       <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: 99999999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div
        className="spinner-border text-white"
        role="status"
        style={{ width: "3rem", height: "3rem" }}>
      </div>
    </div>
  );
};

export default LoadingOverlay;